// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_9dq","cls2":"LoggedInDiscoveryPage-cls2_jM0 LoggedInDiscoveryPage-cls1_9dq"};